import React from 'react';
import { Button, Chip, Stack, Typography } from '@mui/material';
import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';

const READ_LABELS = {
  English: 'Hint',
  French: 'Indice',
  'Simplified Chinese': '提示',
  'Traditional Chinese': '提示',
};
const SKIP_LABELS = {
  English: 'Skip',
  French: 'Passer',
  'Simplified Chinese': '跳过',
  'Traditional Chinese': '跳過',
};

export default function ConversationScaffoldAids({
  choices = [],
  hint = '',
  visible = true,
  disabled = false,
  language = 'English',
  onSelect,
  onSpeak,
  onSkip,
  trailingActions,
}) {
  const items = (Array.isArray(choices) ? choices : []).slice(0, 6).map(
    (choice, index) => ({
      id: choice?.id || `choice-${index}`,
      label: String(choice?.label ?? choice ?? '').trim(),
    })
  ).filter((choice) => choice.label);
  const normalizedHint = String(hint || '').trim();
  const spokenText = [normalizedHint, ...items.map((choice) => choice.label)]
    .filter(Boolean)
    .join('. ');
  if (!spokenText && !onSkip) return null;

  return (
    <Stack spacing={0.75} sx={{ mb: 1 }}>
      {visible && items.length > 0 && (
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          {items.map((choice) => (
            <Chip
              key={choice.id}
              label={choice.label}
              clickable={Boolean(onSelect)}
              disabled={disabled}
              onClick={onSelect ? () => onSelect(choice.label) : undefined}
            />
          ))}
        </Stack>
      )}
      {visible && normalizedHint && (
        <Typography sx={{ fontSize: 13, color: '#4b5563' }}>
          {normalizedHint}
        </Typography>
      )}
      <Stack direction="row" spacing={1} alignItems="center" useFlexGap flexWrap="wrap">
        {onSpeak && spokenText && (
          <Button
            size="small"
            startIcon={<VolumeUpRoundedIcon />}
            disabled={disabled}
            onClick={() => onSpeak(spokenText)}
          >
            {READ_LABELS[language] || READ_LABELS.English}
          </Button>
        )}
        {onSkip && (
          <Button size="small" disabled={disabled} onClick={() => onSkip(SKIP_LABELS[language] || SKIP_LABELS.English)}>
            {SKIP_LABELS[language] || SKIP_LABELS.English}
          </Button>
        )}
        {trailingActions ? (
          <Stack direction="row" spacing={1} alignItems="center" useFlexGap flexWrap="wrap" sx={{ ml: 'auto' }}>
            {trailingActions}
          </Stack>
        ) : null}
      </Stack>
    </Stack>
  );
}

export function EndConversationControl({
  label = 'End conversation', disabled = false, onEnd, sx,
}) {
  return (
    <Button
      size="small"
      variant="text"
      color="inherit"
      startIcon={<StopCircleOutlinedIcon />}
      disabled={disabled}
      onClick={() => onEnd?.(label)}
      sx={sx}
    >
      {label}
    </Button>
  );
}
